'use strict'; // https://github.com/tc39/proposal-iterator-helpers

var $ = require('../internals/export');

var AsyncFromSyncIterator = require('../internals/async-from-sync-iterator');

var WrapAsyncIterator = require('../internals/async-iterator-wrap');

var getIteratorDirect = require('../internals/get-iterator-direct');

$({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  toAsync: function toAsync() {
    return new WrapAsyncIterator(getIteratorDirect(new AsyncFromSyncIterator(this)));
  }
});